import React from 'react'
import { WidgetContent, WidgetTable } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import TableHeader from '../../UI/TableHeader'
import { ModalButton } from '../../UI/ModalButton'
import ModalItem from './ModalItem'

const DriverInfoModal = ({ haul, toggleModal }) => {
  const { haulId, drivers, KPIs, haulLogCount } = haul
  const haulAverage = KPIs.driveTime / haulLogCount

  const driverEfficiencies = Object.values(drivers).sort((a, b) => b.efficiency - a.efficiency)
  return (
    <CreateNewModal title={`${haulId} | Driver Info`} handleCloseModal={toggleModal}>
      <WidgetContent style={{ padding: 0, height: '421px', overflow: 'auto' }}>
        <WidgetTable style={{ position: 'relative' }}>
          <thead>
            <tr>
              {['DRIVER', 'EFFICIENCY', 'HAUL AVERAGE'].map((item, i) => (
                <TableHeader key={i} title={item} />
              ))}
            </tr>
          </thead>
          <tbody>
            {driverEfficiencies.map(({ firstName, lastName, efficiency }) => {
              return (
                <ModalItem
                  key={firstName + lastName}
                  firstName={firstName}
                  lastName={lastName}
                  efficiency={efficiency}
                  haulAverage={haulAverage}
                />
              )
            })}
          </tbody>
        </WidgetTable>
      </WidgetContent>
      <WidgetContent style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ width: '83px' }}>
          <ModalButton success onClick={toggleModal} name="OK" />
        </div>
      </WidgetContent>
    </CreateNewModal>
  )
}

export default DriverInfoModal
